// extracted by mini-css-extract-plugin
export default {"cls1":"Reader-cls1___3d798a010b73fe90ab7","cls2":"Reader-cls2___3ef8766808ad480784a Reader-cls1___3d798a010b73fe90ab7","fullWidth":"Reader-fullWidth__cd79d3296ad9f9440d85"};